import React from 'react';
import { useTranslation } from 'react-i18next';

import { AgentCatalogGrid } from './AgentCatalogGrid';
import { AgentCatalogHeader } from './AgentCatalogHeader';
import { AgentCatalogPagination } from './AgentCatalogPagination';

export interface AgentCatalogLayoutProps {
    searchQuery: string;
    onSearchChange: (query: string) => void;
    onAddAgent: () => void;
    agents: any[];
    isLoading: boolean;
    onChat: (id: string) => void;
    onSettings: (id: string) => void;
    onShare: (id: string) => void;
    onDelete: (id: string) => void;
    currentPage: number;
    totalPages: number;
    paginationRange: (number | string)[];
    onPageChange: (page: number) => void;
}

export const AgentCatalogLayout: React.FC<AgentCatalogLayoutProps> = ({
    searchQuery,
    onSearchChange,
    onAddAgent,
    agents,
    isLoading,
    onChat,
    onSettings,
    onShare,
    onDelete,
    currentPage,
    totalPages,
    paginationRange,
    onPageChange,
}) => {
    const { t } = useTranslation();

    return (
        <div className="flex-1 flex flex-col bg-background pb-20 px-8 max-md:px-6 w-full">
            <div className="text-lg font-medium pt-8  pb-9 max-md:py-4">{t('agent.catalog.title')}</div>
            <AgentCatalogHeader
                searchQuery={searchQuery}
                onSearchChange={onSearchChange}
                onAddAgent={onAddAgent}
                isLoading={isLoading}
            />
            <AgentCatalogGrid
                agents={agents}
                isLoading={isLoading}
                onChat={onChat}
                onSettings={onSettings}
                onShare={onShare}
                onDelete={onDelete}
            />
            <AgentCatalogPagination
                currentPage={currentPage}
                totalPages={totalPages}
                paginationRange={paginationRange}
                onPageChange={onPageChange}
            />
        </div>
    );
};
